import { apiHosts } from "@/api/constants/apiHosts";
import type { ToastOptionsError, ToastOptionsSuccess } from "@modernary/mui/components/toasts";
import { apiService, type Paging, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";
import { serializeQueryParams } from "@modernary/mui/utils/helpers";
import type { Invitation, InvitationQuery } from "./invitation";

const URL = "invitations";
const ENTITY_NAME = "Invitation";

const api = apiService<Invitation>(apiHosts.AQMS, { baseURL: import.meta.env.VITE_AQMS_API_BASE_URL });

/** Always scoped server-side to the authenticated recipient. */
const getInvitations = (params: InvitationQuery = {}, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = "Invitations";
    config?.errorToastCb?.(options);
  };

  return api.getPaged<Paging<Invitation>>(URL, {
    params,
    paramsSerializer: serializeQueryParams,
    successToastCb,
    errorToastCb,
  });
};

const getInvitationByToken = (token: string, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = ENTITY_NAME;
    config?.errorToastCb?.(options);
  };

  return api.get(`${URL}/${token}`, { successToastCb, errorToastCb });
};

const respondToInvitation = (token: string, accept: boolean, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.title = accept ? "Invitation accepted" : "Invitation declined";
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.updated = ENTITY_NAME;
    config?.errorToastCb?.(options);
  };

  return api.post(`${URL}/${token}/${accept ? "accept" : "reject"}`, {}, { successToastCb, errorToastCb });
};

export { getInvitationByToken, getInvitations, respondToInvitation };
